import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const PAGE_TITLE = 'FINANZA PRONTA™ – Il tuo anno di educazione finanziaria, 100% già pronto';
const PAGE_DESCRIPTION = 'Il sistema 6-in-1 di educazione finanziaria per Primaria e Secondaria, in linea con le Linee guida 2024 per l\'educazione civica: programmazione annuale, 12 lezioni minuto per minuto, schede in 3 livelli, 60 attività e giochi, 20 compiti di realtà e 100 giudizi pronti, più 5 bonus. PDF, pagamento unico, garanzia 7 giorni.';
function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'it';
    document.title = PAGE_TITLE;
    setMeta('name', 'description', PAGE_DESCRIPTION);
    setMeta('property', 'og:title', PAGE_TITLE);
    setMeta('property', 'og:description', PAGE_DESCRIPTION);
    setMeta('property', 'og:locale', 'it_IT');
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3uct2xiigokzy">
      <div lang="it" className="w-full bg-stone-50 font-sans text-[#1E2B58] antialiased" data-id="element-1" data-mp="3ubriinfk2m5k">
        <CountdownBar data-id="element-2" data-mp="d3mlpfjtr3m9" />
        <main data-id="element-3" data-mp="d45ti3frgbmk">
          <Hero data-id="element-4" data-mp="d2l936n5u92f" />
          <InsidePages data-id="element-5" data-mp="85l3sxy4xacd" />
          <StatsBar data-id="element-6" data-mp="851n1kk80rzx" />
          <Difference data-id="element-7" data-mp="86w6svjrae2f" />
          <Recognize data-id="element-8" data-mp="86clr5yt79k6" />
          <WhatsInside data-id="element-9" data-mp="83qdf443gq0w" />
          <Bonuses data-id="element-10" data-mp="3gkv2dw2tfxfe" />
          <HowItWorks data-id="element-11" data-mp="3gmfuzg5kl6am" />
          <Audience data-id="element-12" data-mp="3glo067jsrcle" />
          <Offer data-id="element-13" data-mp="3gj1rg4l66r1l" />
          <Guarantee data-id="element-14" data-mp="3bmjsjlcitmx6" />
          <Testimonials data-id="element-15" data-mp="3bn30qacdcwy0" />
          <Faq data-id="element-16" data-mp="3bnuvjiy56qn8" />
          <FinalCta data-id="element-17" data-mp="3bk718hkvi07g" />
        </main>
        <Footer data-id="element-18" data-mp="3qbpnuy88mszs" />
      </div>
    </MotionConfig>;
}